import { disclosureType } from '../../../../choices'
import { choicePage } from '../../../../pages'
import css from '../../../ComplaintForm/ComplaintForm.module.css'

export const protectedDisclosurePage = () => {
  const props = {
    pageId: 'protected_disclosure_page',
    fieldName: 'disclosure_type',
    label: 'What kind of activity did you report?',
    fieldType: 'checkbox',
    className: css.choices,
    labelClassName: css.largeLabel,
    choices: disclosureType()
  }

  const page = choicePage({ ...props })

  return {
    ...page,
    action: {
      type: 'goto',
      pageId: values => {
        return values.disclosure_type == 'Other'
          ? 'protected_disclosure_warning_page'
          : 'protected_communication_page'
      }
    }
  }
}
